import type { PropsWithChildren } from 'preact/compat';
import './DrawerFooter.less';

type DrawerFooterProps = PropsWithChildren<Record<never, never>>;

const DrawerFooter = ({ children }: DrawerFooterProps) => (
    <div className="bri-DrawerFooter">{children}</div>
);

export default DrawerFooter;
